export const changeTypeLabel = {
  QUANTITY: 'Quantity',
  DEPTHLESS: 'Depthless',
  DIMENSION: 'Dimension',
  CORE_MATERIAL: 'Shutter Core',
  SHUTTER_MATERIAL: 'Shutter Material',
  SHUTTER_FINISH: 'Shutter Finish',
  CABINATE_MATERIAL: 'Cabinate Material',
  FRAME_SHUTTER: 'Frame & Shutter',
  SOFT_CLOSE: 'Soft Close',
  AMOUNT: 'Price',
  ACCESSORY_DELETED: 'Accessory deleted',
  VISIBLE_SIDE_CHANGE: 'Visible Side',
  ACCESSORY_ADDED: 'Accessory added',
  ACCESSORY_QTY_UPDATED: 'Accessory quantity',
  INTERNAL_MATERIAL: 'Internal Material',
  GLASS_MATERIAL: 'Glass Material',
  RUNNING_MM: 'Running mm',
  WIDTH: 'Width',
  NAME: 'Name',
  COMMENT: 'Description',
  HEIGHT: 'Height',
  CATEGORY: 'Category',
  LENGTH: 'Length',
  BREADTH: 'Breadth',
  SELECTEDVARIANT: 'Variant',
  SKU: 'SKU',
};

export const MODULE_UPDATED = 'MODULE_UPDATED';
export const MODULE_ADDED = 'MODULE_ADDED';
export const MODULE_DELETED = 'MODULE_DELETED';

export const boolToString = (value) => {
  if (!(typeof value === 'boolean')) {
    return value;
  }

  if (value === true) {
    return 'True';
  }
  return 'False';
};



// WEBPACK FOOTER //
// ./src/components/utils/index.js